<template>
    <div class="global-search-creation__body">
      <el-row :gutter="15" type="flex" justify="center">
        <el-col :xl="8" :lg="10" :sm="14" :xs="20">
          <el-card class="box-card el-card-lg" shadow="never">
            <div v-loading="loading">
              <div class="vue-form">
                <el-form ref="ruleForm">
                  <el-row :gutter="15" type="flex" justify="center">
                    <el-col :md="12" :xs="24">
                      <div class="case-creation__input">
                        <el-form-item>
                          <label for="text">Select Start Date</label>
        
                          <el-date-picker
                            type="date"
                            v-model="start_date"
                            format="MM-DD-YYYY"
                            value-format="YYYY-MM-DD"
                            placeholder="Select Start Date"
                            :editable="false"
                            :disabled-date="disabledDate"
                            clearable
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :md="12" :xs="24">
                      <div class="case-creation__input">
                        <el-form-item>
                          <label for="text">Select End Date</label>
                          <el-date-picker
                            type="date"
                            v-model="end_date"
                            format="MM-DD-YYYY"
                            value-format="YYYY-MM-DD"
                            placeholder="Select End Date"
                            :editable="false"
                            :disabled-date="disabledDate"
                            clearable
                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xl="24" :lg="24" :sm="12" :xs="20">
                      <div class="global-search-btn text-center mt-15">
                        <el-button class="btn button-with-icon" @click="searchedCases" :disabled="!start_date || !end_date">
                          <div class="search-icon">                          
                            <h4>DOWNLOAD</h4>
                          </div>
                        </el-button>                      
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
</template>
<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            loading:false,
            start_date:"",
            end_date:"",
            disabledDate: (time) => {
            return time.getTime() > Date.now();
            }
        } 
    },
    computed:{
        ...mapGetters("cases",["getDownloadTrumedDataStatus"])
    },
    methods:{
       async searchedCases(){
            try{
                this.loading = true
                let params = {
                    from_date:this.convertToLabUTC(this.start_date),
                    to_date:this.convertToLabUTC(this.end_date)
                }
                await this.$store.dispatch("cases/downloadTrumedData",params)
                this.start_date = "",
                this.end_date = ""
                this.loading = false
            } catch(error){
                this.loading = false
                console.log(error)
            }
        }
    }

}
</script>
<style lang="scss">
.global-search-creation__body {
  .el-card {
    margin-top: calc(50vh - 200px);
  }
  .el-input__inner {
    background: #ffffff;
    padding-right: 25px !important;
    padding-left: 5px;
    color: #000;
    border: 0.922417px solid rgba(156, 156, 156, 0.5);
    font-weight: 500;
    font-size: 13px;
    height: 28px;
    box-sizing: border-box;
    border-radius: 3.56227px;
    height: 30px !important;
    &::placeholder {
      color: #bdbdbd;
      opacity: 0.8;
      font-weight: 500;
      font-size: 13px;
      letter-spacing: 0;
    }
  }
}
</style>
